//
//
//
//
//
//
//
//
//
//
//
//
//

import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoNumerico',
  props: {
    value: {
      type: [Number],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  data() {
    return {
      valorInterno: null,
      rules: {
        requiredNome: () => {
          if (!this.campoObrigatorio) {
            return true;
          }
          const msg = this.$t('message.campo_obrigatorio');
          const val = this.valorInterno;
          return !!(val) || msg;
        },
        numeroValido: () => {
          if (!this.valorInterno) return true;

          const msg = this.$t('message.numero_invalido');
          const val = this.valorInterno;
          return (!!(val) && !isNaN(val.toString())) || msg;
        },
        intervaloValido: () => {
          if (!this.valorInterno) return true;

          const { desAtributos } = this.metadados;
          if (!desAtributos || !desAtributos.max || !desAtributos.min) {
            return true;
          }
          const { max, min } = desAtributos;

          const msg = this.$t('message.intervalo_numerico', desAtributos);
          const val = this.valorInterno;
          return (!!(val) && val <= max && val >= min) || msg;
        },
      },
    };
  },
  methods: {
    numeroAlterado(valor) {
      if (valor) {
        this.emiteValorAlterado(Number(valor));
      } else {
        this.emiteValorAlterado(null);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoNumerico.vue?vue&type=script&lang=js&